import React from 'react';
import { PulseCheckWrapper } from '../PulseCheck.wrapper';
import { Results } from './Results';

interface Props {
  clientId: string;
}

export default (props: Props) => {
  return (
    <PulseCheckWrapper>
      <Results {...props} />
    </PulseCheckWrapper>
  );
};
